// src/hooks/useFontanaData.js

import { useState, useEffect } from 'react';
import web3Service from '../Services/web3Services';
import { CONTRACTS } from '../utils/constants';
import fontanaABI from '../Contracts/fontanaABI.json';

const useFontanaData = () => {
  const [contract, setContract] = useState(null);
  const [contractAddress, setContractAddress] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

   // Contract data
  const [data, setData] = useState({
    totalSupply: null,
    maxSupplyLimit: null,
    totalTokensBurned: null,
    totalTradeVolume: null,
    name: null,
    symbol: null,
    decimals: null,
    owner: null
  });

  // Initialize contract - runs ONCE
  useEffect(() => {
    console.log('🔵 useFontanaData: Initializing...');
    
    try {
      const fontanaContract = web3Service.getContract(
        fontanaABI, 
        CONTRACTS.FONTANA
      );
      
      if (fontanaContract) {
        setContract(fontanaContract);
        setContractAddress(CONTRACTS.FONTANA);
        console.log('✅ Fontana contract created:', CONTRACTS.FONTANA);
      } else {
        throw new Error('Failed to create contract');
      }
    } catch (err) {
      console.error('❌ useFontanaData error:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  }, []); // Empty deps = runs ONCE

    // Fetch contract data - runs when contract is ready
  useEffect(() => {
    if (!contract) return;

    const fetchData = async () => {
      console.log('🔵 Fetching Fontana data...');
      
      try {
        // Fetch all data in parallel
        const [
          totalSupply,
          maxSupplyLimit,
          totalTokensBurned,
          totalTradeVolume,
          name,
          symbol,
          decimals,
          owner
        ] = await Promise.all([
          web3Service.call(contract, 'totalSupply'),
          web3Service.call(contract, 'maxSupplyLimit'),
          web3Service.call(contract, 'totalTokensBurned'),
          web3Service.call(contract, 'totalTradeVolume'),
          web3Service.call(contract, 'name'),
          web3Service.call(contract, 'symbol'),
          web3Service.call(contract, 'decimals'),
          web3Service.executeRead(contract, 'owner')  
        ]);


        setData({
          totalSupply,
          maxSupplyLimit,
          totalTokensBurned,
          totalTradeVolume,
          name,
          symbol,
          decimals,
          owner
        });
      } catch (err) {
        console.error('❌ Error fetching Fontana data:', err);
        setError(err.message);
      }
    };

    fetchData();
  }, [contract]); // Runs when contract is ready

  return {
    contract,
    contractAddress,
    isLoading,
    error,
    hasContract: !!contract,
    data
  };
};

export default useFontanaData;